export default __webpack_public_path__ + "static/media/Group8878.88e7a67c.svg";